"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dotBg = exports.dot = exports.dotWrapper = exports.storyLogo = void 0;

var _util = require("../../../util");

const getPurpleColor = theme => (0, _util.color)(theme, 'interactive.primary.default');

const storyLogo = ({
  cssProps,
  theme
}) => {
  const {
    variant,
    size
  } = cssProps;
  const defaultBorderColor = (0, _util.color)(theme, 'ui4');
  const purpleColor = getPurpleColor(theme);

  const getBorderColor = () => {
    switch (variant) {
      case 'active':
      case 'pulsing':
        return purpleColor;

      case 'notActive':
      default:
        return defaultBorderColor;
    }
  };

  return {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: size,
    height: size,
    border: "2px solid ".concat(getBorderColor()),
    borderRadius: '50%',
    zIndex: 3,
    '& > img': {
      maxWidth: '100%',
      borderRadius: '50%',
      position: 'relative',
      zIndex: 2
    }
  };
};

exports.storyLogo = storyLogo;

const dotWrapper = ({
  cssProps
}) => {
  const {
    top,
    left
  } = cssProps;
  return {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    top,
    left
  };
};

exports.dotWrapper = dotWrapper;

const dot = ({
  theme
}) => {
  const purpleColor = getPurpleColor(theme);
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'block',
    background: purpleColor,
    width: 6,
    height: 6,
    boxSizing: 'unset',
    borderRadius: '50%',
    zIndex: 3
  };
};

exports.dot = dot;

const dotBg = ({
  theme,
  cssProps
}) => ({
  zIndex: 1,
  width: cssProps.size,
  height: cssProps.size,
  background: (0, _util.color)(theme, 'ui2'),
  borderRadius: '50%'
});

exports.dotBg = dotBg;
//# sourceMappingURL=StoryLogo.styles.js.map